import { Component, OnInit, Inject, forwardRef, OnDestroy } from '@angular/core';
import { OrchestrationService } from '../services/orchestration-service/orchestration.service';
import { Customer, Email, PhoneNumber, CustomerAddress, AddressTranslation } from './customer.model';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppState } from '../../store/state.model';
import { NgRedux, select } from '@angular-redux/store';
import { AdminDispatcher } from '../../store/admin-store/admin-dispatcher';
import { SidenavService } from '../services/sidenav.service';
import { State, statesCA, statesMX, statesUS } from '../services/states';
import { countries, Country } from '../services/countries';
import { TranslationService } from '../../common/services/languages/translation.service';
import { SpinnerRef } from '../../common/components/spinner/overlay-ref.service';
import { SpinnerService } from '../../common/components/spinner/overlay-spinner.service';
import { AdminApiHandlerService } from '../services/api-handler/api-handler.service';
import { environment } from '../../../environments/environment';
import { SnackBarService } from '../../common/services/snack-bar/snack-bar.service';
import { PhonePipe } from '../../common/pipes/phone.pipe';
import { preferredLanguage } from './preferred-language/preferred-language';
import { MatDialog } from '@angular/material';
import { VerifyAddressComponent } from './verify-address/verify-address.component';
import { ApiResponseActions } from '../../store/api-response/api-response-actions';
import { ApiResponseState } from '../../store/api-response/api-response-state.model';
import { Observable, Subscription } from 'rxjs';
import { UpdateState } from '../../store/update-customer/update-state.model';
import { UpdateDispatcher } from '../../store/update-customer/update-dispatcher';
import { regex } from '../../common/regex.constants';
import { FinegrainRolesService } from '../../common/services/finegrain-roles/finegrain-roles.service';
import { CustomerDispatcher } from '../../store/customer/customer-dispatcher';
import { SelectedVehicleState } from '../../store/selected-vehicle-store/selected-vehicle-state.model';
import { parseIsoDate, transformDateTimeLogin } from '../../common/helpers/utils';
import { CustomerState } from '../../store/customer/customer-state.model';
import { NgIf, NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatError, MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { PostalCodeDirective } from '../../common/pipes/directives/postal-code.directive';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { GuidAlignmentComponent } from './guid-alignment/guid-alignment.component';
import { AdvancedFeaturesComponent } from './advanced-features/advanced-features.component';
import { LinkedAccountsComponent } from '../subscription/linked-accounts/linked-accounts.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgIf, MatButton, MatFormField, MatInput, MatLabel, MatError, MatSelect, NgFor, MatOption, PostalCodeDirective, MatIcon, MatTooltip, GuidAlignmentComponent, AdvancedFeaturesComponent, LinkedAccountsComponent, TranslatePipe]
})
export class CustomerComponent implements OnInit, OnDestroy {
  /**
   * @property Property to store customer form
   */
  public customerForm: UntypedFormGroup;
  /**
   * @property Property to store customer preferred language
   */
  public lang: string;
  /**
   * @property Property to store customer information
   */
  public customer: Customer;
  /**
   * @property Property to store available states
   */
  public states: State[];
  /**
   * @property Property to store zipcode length
   */
  public zipCodeLength: string;
  /**
   * @property Property to store the edit mode
   */
  public editMode: boolean;
  /**
   *@property Reference to the spinner service so it can be open or close in any feature of the screen
   **/
  public spinnerRef: SpinnerRef;
  /**
   * @property Property to store customer email information
   */
  public customerEmail: Email;
  /**
   * @property Property to store customer phone information
   */
  public customerPhone: PhoneNumber;
  /**
   * @property Property to store customer address information
   */
  public customerAddress: CustomerAddress;
  /**
   * @property Property used to store customer's guid
   */
  public guid: string;
  /**
   * @property Property used to store customer's email verification
   */
  public emailVerified: boolean;
  /**
   * @property Property used to store customer's phone verification
   */
  public phoneVerified: boolean;
  /**
  * @property Property used to store customer's country
  */
  public country: string;
  /**
   *@property Property used to know In what mode is going to used the component
  **/
  public mode: string;
  /**
    *@property Property used to store the create source of the customer
  **/
  public createSource: string;
  /**
   *@property Property used to store the preferred languages list
  **/
  public preferredLanguageList: Array<object>;

  /**
   *@property Property used to store the verified addresses list
  **/
  public verifiedAddresses: Array<object>;
  /**
   *@property apiObservable Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;

  /**
   * @property Property used to store the customer form values
   */
  public customerFormValues: object;

  /**
   * @property verifyAddressRef to store the reference of the verify address dialog
   */
  private verifyAddressRef: any;
  /**
   * @property countries to store the reference of the verify address dialog
   */
  public countries: Array<Country>;
  /**
   * @property addressSubscriber to store the address subscription
   */
  private addressSubscriber: Subscription;
  /**
   * @property signupType to store the signup type
   */
  public signupType: string;
  /**
   * @property regex to store the regex values
   */
  public regex: any;
  /**
   * @property addressTranslation property is provided translations of address.
   */
  private addressTranslation: AddressTranslation;
  /**
   *@property observe update redux
   **/
  @select('update') readonly updateAccountObservable: Observable<UpdateState>;
  /**
  *@arg selectedVehicleObservable to observe selectedVehicle observable
  **/
  @select('selectedVehicle') readonly selectedVehicleObservable: Observable<SelectedVehicleState>;
  /**
   * @property used to store the  subscription
   */
  public selectedVehicleSubscriber: Subscription;
  public updateSubscriber: Subscription;
  private apiSubscription: Subscription;
  private languageSubscriber: any;
  /**
   * @property used to store the selected vehicle brand
   */
  public vehicleBrand: string;
  /**
   * @property used to store the loginSource details
   */
  public loginSource: string;
  /**
   * @property used to store the lastLoginTime details
   */
  public lastLoginTime: any;
  /**
  * @property used to store the vehicle generation
  */
  public vehicleGeneration: string;
  /**
   * @property used to store the boolean when customer has any subscriptions
   */
  public isSubscribedCustomer: boolean;
  /**
   * @property used to store the customer data
   */
  public customerdata: object;
  /**
   * @property to hold the linked accounts visibility
   */
  public enableLinkedAccounts = false
  /**
   * @property to observe the redux customer store
   */
  @select('customer') readonly customerObservable: Observable<CustomerState>;
  /**
   * @property to store customer store subscription reference
   */
  private customerSub: Subscription;
  /**
   * @property to track the last loaded customer GUID
   */
  private lastGuid: string = '';
  /**
   * @property Enabled or Disabled from GET /v1/portal/consent/account
   */
  private smsConsentStatus = '';
  /**
   * @property true once an SMS consent response has been applied for the current account
   */
  private smsConsentsLoaded = false;
  /**
   * @property customer and brand of the latest SMS request. Skips a duplicate call for the same account.
   */
  private smsConsentContextKey = '';
  /**
   * @property id of the latest SMS request, issued by the shared service.
   * An older response, including one from a previous search, is ignored.
   */
  private smsConsentRequestId = '';

  constructor(
    @Inject(forwardRef(() => AdminApiHandlerService)) public apiHandler: AdminApiHandlerService,
    public fb: UntypedFormBuilder,
    private orchestrationService: OrchestrationService,
    public reduxState: NgRedux<AppState>,
    private adminDispatcher: AdminDispatcher,
    public translate: TranslationService,
    private sidenav: SidenavService,
    public spinner: SpinnerService,
    private snackBarService: SnackBarService,
    public phonePipe: PhonePipe,
    public dialog: MatDialog,
    public updateDispatcher: UpdateDispatcher,
    public finegrainRolesService: FinegrainRolesService,
    public customerDispatcher: CustomerDispatcher
  ) {
    this.editMode = false;
    this.preferredLanguageList = preferredLanguage;
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit() {
    this.countries = countries;
    this.regex = regex;
    this.languageSubscriber = this.translate.languageChange().subscribe((language: object) => {
      this.lang = language['lang'];
    });

    this.apiSubscription = this.apiObservable.subscribe((api) => {
      // Following condition will be commented out untill the planned enhancement is made for
      // verify address feature.
      // if (api.apiAction === ApiResponseActions.SET_VERIFY_ADDRESS && api.verifyAddress['type'] === 'success') {
      //   this.spinnerRef = this.spinner.open();
      //   this.verifiedAddresses = api.verifyAddress['payload']['addresses'];
      //   if (this.verifiedAddresses && this.verifiedAddresses.length > 1) {
      //     this.openVerifyAddress(this.verifiedAddresses);
      //   } else if (this.verifiedAddresses && this.verifiedAddresses.length === 1) {
      //     this.updateCustomer();
      //   }
      //   this.spinnerRef.close();
      // }
      if (api.apiAction === ApiResponseActions.SET_UPDATE_CUSTOMER && !!api.customer['customer'] && api.customer['type'] === 'success') {
        this.updateSuccess(api.customer['customer']);
      }
      if (api.apiAction === ApiResponseActions.SET_UPDATE_CUSTOMER && !!api.customer['customer'] && api.customer['type'] === 'error') {
        this.updateError();
      }
      if (api.apiAction === ApiResponseActions.GET_SMS_CONSENT && api.apiResponse['type'] === 'success' && !!api.apiResponse['payload']
        && this.isCurrentSmsConsentResponse(api.apiResponse)) {
        this.applyAccountSmsStatus(api.apiResponse['payload']);
      }
      if (api.apiAction === ApiResponseActions.GET_SMS_CONSENT && api.apiResponse['type'] === 'error'
        && this.isCurrentSmsConsentResponse(api.apiResponse)) {
        // A failed call must not block the next refresh of this same account.
        this.smsConsentContextKey = '';
        this.smsConsentsLoaded = false;
        this.smsConsentStatus = '';
        this.applySmsConsent('');
        this.updateError();
      }
      if (api.apiAction === ApiResponseActions.SET_SUBSCRIBED_CUSTOMER && api.subscribedCustomer['type'] === 'success') {
        this.isSubscribedCustomer = true;
        this.reduxState.getState().customer.data = api['subscribedCustomer']['customer'];
        this.default();
      }
    });

    this.updateSubscriber = this.updateAccountObservable.subscribe((update) => {
      if (!!update.isUpdated) {
        this.default();
        this.updateDispatcher.resetUpdate();
      }
    });
    this.default();
    this.customerSub = this.customerObservable.subscribe((state) => {
    const guid = state && state['data'] ? (state['data']['guid'] || '') : '';
    if (!this.editMode && guid && guid !== this.lastGuid) {
      this.lastGuid = guid;
      this.smsConsentsLoaded = false;
      this.smsConsentStatus = '';
      this.smsConsentContextKey = '';
      this.default();
      this.loadAccountSmsConsent();
      }
    if (!guid) {
      this.lastGuid = '';
      this.smsConsentsLoaded = false;
      this.smsConsentStatus = '';
      this.smsConsentContextKey = '';
      }
    });
    this.selectedVehicleSubscriber = this.selectedVehicleObservable.subscribe({
      next: ({ vehicle }) => {
      if (vehicle) {
        const brand = vehicle['brand'] || vehicle['brandCode'] || '';
        this.vehicleBrand = brand[0] && brand[0].toLowerCase() === 't' ? 'TOYOTA' : brand[0] && brand[0].toLowerCase() === 's' ? 'SUBARU' : 'LEXUS';
        this.vehicleGeneration = vehicle['generation'];
        this.loadAccountSmsConsent(vehicle);
      }
    },
      complete: () => this.selectedVehicleSubscriber.unsubscribe()
    }
    );
    const vehicle = this.reduxState.getState().selectedVehicle.vehicle;
    const LinkedAccountsNotEligibleGenerations = ['17cyplus', '17cy'];
    this.enableLinkedAccounts = !!vehicle && !!vehicle['generation'] && LinkedAccountsNotEligibleGenerations.includes(vehicle['generation'].toLowerCase()) ? false : true

  }
  /**
   * @function getPermission get Permissions to display features inside customer card
   */
  public getPermission(feature: string): boolean {
    return this.finegrainRolesService.getCustomerPermissions(feature);
  }
  /**
   * @function ngOnDestroy Method to perform component last operations when it is destroyed
   */
  ngOnDestroy() {
    if (this.languageSubscriber) { this.languageSubscriber.unsubscribe(); }
    if (this.apiSubscription) { this.apiSubscription.unsubscribe(); }
    if (this.selectedVehicleSubscriber) { this.selectedVehicleSubscriber.unsubscribe(); }
    if (this.updateSubscriber) { this.updateSubscriber.unsubscribe(); }
    if (this.customerSub) { this.customerSub.unsubscribe(); }
  }

  /**
   * @function default should intialize the values of form
   * @returns void
   */
  public default(): void {
    const { customer: { searchValue: defaultSearchValue, data } } = this.reduxState.getState();
    this.customer = new Customer(data);
    this.guid = data['guid'];
    this.createSource = this.customer.getCreateSource(data['createSource']);
    this.emailVerified = data['emails'] && String(data['emails'][0]['emailVerified']) === 'true';
    this.phoneVerified = data['phoneNumbers'] && String(data['phoneNumbers'][0]['phoneVerified']) === 'true';
    this.country = data['addresses'] && data['addresses'][0]['country'];
    this.setStates = data['addresses'] && data['addresses'][0]['country'];
    this.customerForm = this.fb.group(this.customer.form);
    this.loginSource = data['loginSource'];
    this.lastLoginTime = data['lastLoginTime'] ? transformDateTimeLogin(parseIsoDate(data['lastLoginTime'])) : '';
    this.customerFormValues = {
      firstName: this.customer.values['firstName'],
      lastName: this.customer.values['lastName'],
      email: this.customer.values['email'],
      phoneNumber: !!this.customer.values['phoneNumber'] ? '+' + this.customer['data']['phoneNumbers'][0]['countryCode'] + this.phonePipe.transform(this.customer.values['phoneNumber']) : '',
      customerType: this.customer.values['customerType'],
      guid: this.customer.values['guid'],
      objectId: this.customer.values['objectId'],
      preferredLanguage: this.customer.values['preferredLanguage'],
      createSource: this.customer.values['createSource'],
      lastUpdateSource: this.customer.values['lastUpdateSource'],
      lastUpdateDate: this.customer.values['lastUpdateDate'],
      createDate: this.customer.values['createDate'],
      uiLanguage: this.customer.values['uiLanguage'],
      address: this.customer.values['address'],
      city: this.customer.values['city'],
      state: this.customer.values['state'],
      zip: this.customer.values['zip'],
      country: this.customer.values['country'],
      signupType: this.customer.values['signupType'],
      smsConsent: this.smsConsentsLoaded ? this.smsConsentStatus : ''
    };
    this.customerForm.setValue(this.customerFormValues);
    this.setNameValidator(this.customer.data);
    if (this.guid) {
      this.setAddressValidators();
      this.disableFormFields();
    }
    this.addressTranslation = new AddressTranslation(this.translate);
  }

  /**
   * @method get addressTranslator property that provides translations of address by selected country.
   */
  public get addressTranslator(): AddressTranslation {
    return this.addressTranslation.getCountry(this.customerForm.controls.country.value);
  }
  /**
   * @method countryChanged sets the selected country in the model
   */
  public countryChanged(country: string): void {
    this.customerForm.setValue({ ...this.customerFormValues, country, zip: '' });
    const zipPattern = country === 'CA' ? regex.zipCodeCAPattern : regex.zipCodeUSPattern;
    this.customerForm.get('zip').setValidators([Validators.required, Validators.pattern(zipPattern)]);
    this.customerForm.get('state').setValidators([Validators.required]);
    this.country = country;
    this.customerForm.controls.state.setValue('');
    this.customerForm.controls.zip.setValue('');
    this.customerForm.controls.state.markAsTouched();
    this.customerForm.controls.zip.markAsTouched();
    this.customerForm.updateValueAndValidity();
    // Update address translation to reflect the new country
    this.addressTranslation = new AddressTranslation(this.translate);
  }
  /**
   * @method setNameValidator validates the socialType of customer to allow firstName and lastName with special characters
   */
  public setNameValidator(customer): void {
    if (this.checkSignUpType(customer)) {
      this.customerForm.get('firstName').setValidators([
        Validators.required,
        Validators.maxLength(64),
        Validators.pattern(regex.socialWordCount),
        Validators.pattern(regex.precedingAndTrailingSpaces),
        Validators.pattern(regex.socialFirstNamePattern)
      ]);
      this.customerForm.get('lastName').setValidators([
        Validators.required,
        Validators.maxLength(64),
        Validators.pattern(regex.socialWordCount),
        Validators.pattern(regex.precedingAndTrailingSpaces),
        Validators.pattern(regex.socialLastNamePattern)
      ]);
    } else {
      this.customerForm.get('firstName').setValidators([
        Validators.required,
        Validators.maxLength(64),
        Validators.pattern(regex.precedingAndTrailingSpaces),
        Validators.pattern(regex.firstNameBusiness)
      ]);
      this.customerForm.get('lastName').setValidators([
        Validators.required,
        Validators.maxLength(64),
        Validators.pattern(regex.precedingAndTrailingSpaces),
        Validators.pattern(regex.lastNameBusiness)
      ]);
    }
  }

  /**
   * @method checkSignUpType checks if the customer signed up with a social account
   */
  public checkSignUpType(customer): boolean {
    const socialAccounts = ['google', 'facebook', 'apple'];
    return socialAccounts.includes(new String(customer.signupType).toLowerCase()) && new String(customer.customerType).toLowerCase() !== 'business';
  }

  /**
   * @method getNamePatternErrorMessage returns the proper name error message for first and last name form
   */
  public getNamePatternErrorMessage(customer) {
    return this.checkSignUpType(customer) ?
      'customer.validations.social-name-pattern' :
      'customer.validations.name-pattern';
  }

  /**
   * @method toggleEditMode sets the edit mode and restores the data if canceled
   */
  public toggleEditMode() {
    if (this.editMode) {
      this.disableFormFields();
      this.default();
    } else {
      this.enableFormFields();
      this.markFormGroupTouched(this.customerForm);
    }
    this.editMode = !this.editMode;
  }
  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  /**
   * @method disableFormFields disables form fields
   */
  public disableFormFields() {
    this.customerForm.controls.firstName.disable();
    this.customerForm.controls.lastName.disable();
    this.customerForm.controls.country.disable();
    this.customerForm.controls.city.disable();
    this.customerForm.controls.address.disable();
    this.customerForm.controls.zip.disable();
    this.customerForm.controls.state.disable();
  }
  /**
  * @method enableFormFields enables form fields
  */
  public enableFormFields() {
    this.customerForm.controls.firstName.enable();
    this.customerForm.controls.lastName.enable();
    this.customerForm.controls.city.enable();
    this.customerForm.controls.country.enable();
    this.customerForm.controls.address.enable();
    this.customerForm.controls.zip.enable();
    this.customerForm.controls.state.enable();
  }
  /**
   * @method isValidAddress returns true if the validaton of address fields are true.
   * */
  public isValidAddress(): boolean {
    return this.customerForm.controls['firstName'].valid &&
      this.customerForm.controls['lastName'].valid &&
      this.customerForm.controls['city'].valid &&
      this.customerForm.controls['address'].valid &&
      this.customerForm.controls['zip'].valid &&
      this.customerForm.controls['country'].valid &&
      this.customerForm.controls['state'].valid &&
      !this.customerForm.controls.state.hasError('required') &&
      !this.customerForm.controls.zip.hasError('required');
  }

  /**
   * @method toggleSidenav toggles the side nav
   **/
  public toggleSidenav(updateAttribute: string): void {
    let _value: any = '';
    if (updateAttribute === 'email') {
      _value = this.customerFormValues['email'] ? this.customerFormValues['email'] : '';
    } else if (updateAttribute === 'phone') {
      _value = this.customerFormValues['phoneNumber'] ? this.customerFormValues['phoneNumber'].length === 16 ? this.customerFormValues['phoneNumber'].slice(3, 16) : this.customerFormValues['phoneNumber'].slice(2, 15) : '';
    } else if (updateAttribute === 'delete') {
      _value = this.customerFormValues;
    }
    this.adminDispatcher.setUpdateInfo('account', updateAttribute, _value, this.customerFormValues['lastUpdateDate']);
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }
  /**
   * @function setStates Function to set the states list based on country
   * @param {string} country Possible values US and CA
   **/
  public set setStates(country: string) {
    this.states = country === 'CA' ? statesCA : statesUS;
  }
  /**
   * @function getZipCodeLength returns the length of zip code
   * @returns max length
   **/
  private getZipCodeLength(country: string): string {
    return country === 'US' ? '10' : '7';
  }
  /**
   * @function getDisplayName get the display name for state
   * @param {string} object Possible values US and CA state object
   **/
  public getDisplayName(object: object): string {
    return object[['fr', 'sp', 'en'].indexOf(this.lang) > -1 ? `viewValue_${this.lang}` : 'viewValue_en'];
  }
  /**
    * @function updateCustomer api call to update the address
    **/
  public updateCustomer(): void {
    const guid = this.customer['data']['guid'];
    this.getvehicleList(guid);
  }
  /**
    * @function updateAccount update account api call
    **/
  updateAccount(vehiclebrands, generation) {
    this.orchestrationService.updateCustomer(this.getUpdateBody(), vehiclebrands, generation);
  }
  /**
   * @function updateSuccess Action after a successful customer update
   */
  private updateSuccess(customer: object): void {
    this.customerDispatcher.setCustomerData(customer);
    this.snackBarService.showToast(this.translate.getCustomTranslation('update-account.labels.updated-successfully')['value']);
    this.toggleEditMode();
  }
  /**
   * @function updateError Action after a successful customer update
   */
  private updateError(): void {
    this.snackBarService.showToast(this.translate.getCustomTranslation('errors.error-ocurred')['value']);
  }
  /**
  * @function getvehicleList prepares a vin list
  */
  private getvehicleList(guid) {
    let generation = '17CYPLUS';
    let vehiclebrands = '';
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(environment.admin.apis.subscription.vehicleAssociation, {
      type: 'vehicle_list', params: {
        guid: guid
      }
    }).subscribe({
      next: (res) => {
        if (res.payload && res.payload.length > 0) {
          const brand: Array<any> = res.payload.map(vehicle => vehicle.brand);
          const vehicleGeneration: Array<any> = res.payload.map(vehicle => vehicle.generation);
          generation = vehicleGeneration.includes('PRE17CY') ? 'PRE17CY' : vehicleGeneration.includes('17CY') ? '17CY' : '17CYPLUS';
          vehiclebrands = brand.includes('T') ? vehiclebrands + 'T' : vehiclebrands;
          vehiclebrands = brand.includes('L') ? vehiclebrands + 'L' : vehiclebrands;
          vehiclebrands = brand.includes('S') ? vehiclebrands + 'S' : vehiclebrands;
        }
        this.updateAccount(vehiclebrands, generation);
        spinnerRef.close();
      },
      error: () => {
        this.updateAccount(vehiclebrands, generation);
        spinnerRef.close();
      }
    });
  }
  /**
    * @function getUpdateBody formats the update body
    **/
  private getUpdateBody(): object {
    const updateParams = { guid: this.customer['data']['guid'], objectId: this.customer['data']['objectId'] };
    const { firstName, lastName, city, zip, state, address, country } = this.customerForm.value;
    const addressType = this.customer.data['addresses'] && this.customer.data['addresses'][0]['addressType'] || 'HOME';

    const updateUser = {
      firstName,
      lastName
    };
    let updateAddress;

    if (city && zip && state && address && country) {
      updateAddress = {
        addresses: [
          {
            addressType,
            country,
            city,
            zipCode: zip,
            state,
            address
          }
        ]
      };
    }
    return { customer: Object.assign({ userID: this.reduxState.getState().auth.email }, updateParams, updateAddress, updateUser) };
  }
  /**
   * @function verifyAddress Method used to format address before verify it
   */
  public verifyAddress(): void {
    const { firstName, lastName, city, zip, state, address, country } = this.customerForm.value;
    this.customerFormValues = { ...this.customerFormValues, ...{ firstName, lastName } };
    const addressType = this.customer.data['addresses'] && this.customer.data['addresses'][0]['addressType'] || 'HOME';
    // (city && zip && state && address && country) ? this.getVerifyAddress({
    //   addresses: [{
    //     addressType, country, city,
    //     zipCode: zip, state, address
    //   }]
    // }) : this.updateCustomer();
    this.updateCustomer();

  }
  /**
   * @function getVerifyAddress action to verify address
   **/
  private getVerifyAddress(address: object): void {
    this.orchestrationService.getVerifyAddress(address);
  }
  /**
   * @function openVerifyAddress action to open address verification modal
   **/
  private openVerifyAddress(addresses): void {
    this.verifyAddressRef = this.dialog.open(VerifyAddressComponent, {
      data: { addresses }
    });
    this.addressSubscriber = this.verifyAddressRef.afterClosed().subscribe(address => this.verifyAddressClosed(address));
  }
  /**
   * @function verifyAddressClosed action to verify when the address validation is closed
   **/
  private verifyAddressClosed(address): void {
    if (address) {
      const verifiedAddress = {
        address: `${address['address1']} ${address['address2'] ? address['address2'] : ''}`,
        city: address['city'],
        state: address['state'],
        zip: address['zipCode'],
        country: address['country'],
      };
      this.customerFormValues = { ...this.customerFormValues, ...verifiedAddress };
      this.customerForm.setValue(this.customerFormValues);
      this.updateCustomer();
      this.addressSubscriber.unsubscribe();
      this.verifyAddressRef = undefined;
    }
  }
  /**
   * @function getStatesList action to get the states list when the country has changed
   **/
  public getStatesList(country: any): Array<object> {
    return country.value === 'CA' ? statesCA : country.value === 'US' ? statesUS : statesMX
  }
  /**
   * @function getZipCodeTranslation action get the zipcode/postal code translation when the country has changed
   **/
  public getZipCodeTranslation(country: any): string {
    const translationString = country.value === 'CA' ? 'address.form.postal-code' : 'address.form.zip';
    return this.translate.getCustomTranslation(translationString)['value'];
  }
  /**
   * @function getZipPattern action to get the pattern based on country
   */
  public getZipPattern(country): any {
    return country === 'CA' ? regex.zipCodeCAPattern : regex.zipCodeUSPattern;
  }
  /**
   * @function setAddressValidator action to set the address validators if the values exists
   */
  public setAddressValidators() {
    const address = this.customerFormValues['address'] ? this.customerForm.get('address').setValidators(Validators.required) : null;
    const country = this.customerFormValues['country'] ? this.customerForm.get('country').setValidators(Validators.required) : null;
    const state = this.customerFormValues['state'] ? this.customerForm.get('state').setValidators(Validators.required) : null;
    const zip = this.customerFormValues['zip'] ? this.customerForm.get('zip').setValidators(Validators.required) : null;
    const city = this.customerFormValues['city'] ? this.customerForm.get('city').setValidators(Validators.required) : null;
  }
  /**
   * @function getEmailPhoneValidation action to get the validation of the email and phone
   */
  public getEmailPhoneValidation() {
    const { customer: { data: customerData } } = this.reduxState.getState();
    const emailVerified = !!customerData && customerData['emails'] && String(customerData['emails'][0]['emailVerified']) === 'true';
    const phoneVerified = !!customerData && customerData['phoneNumbers'] && String(customerData['phoneNumbers'][0]['phoneVerified']) === 'true';
    return { emailVerified, phoneVerified };
  }

  /**
   * @function toggleAppFeaturesSidenav toggles the side nav to open the app features
   **/
  public toggleSidenavComponent(componentName: string): void {
    this.adminDispatcher.setUpdateInfo(componentName, '', '', '');
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }

  /**
   * SMS consent is account-level. GET /v1/portal/consent/account returns Enabled or Disabled
   * for consent id B2. The same value is shown for email search and VIN search.
   */
  private applyAccountSmsStatus(payload: any): void {
    const raw = String(payload?.status || '').trim().toLowerCase();
    this.smsConsentStatus = raw === 'enabled' ? 'Enabled' : 'Disabled';
    this.smsConsentsLoaded = true;
    this.applySmsConsent(this.smsConsentStatus);
  }

  /**
   * Fetch SMS consent once the account guid and a Toyota or Lexus brand are known.
   * VIN is not required. Subaru and any other brand are skipped because the portal API rejects them.
   */
  private loadAccountSmsConsent(vehicle?: any): void {
    const state = this.reduxState.getState();
    const customer = state?.customer?.data ?? {};
    const selectedVehicle = state?.selectedVehicle?.vehicle ?? {};
    const selected = vehicle && (vehicle['vin'] || vehicle['subscriberGuid'] || vehicle['brand'] || vehicle['brandCode'])
      ? vehicle
      : (selectedVehicle || {});
    const guid = customer['guid'] || selected['subscriberGuid'];
    const brand = this.portalSmsBrand(selected['brand'] || selected['brandCode'] || '');
    if (!guid || !brand) {
      return;
    }
    const contextKey = [guid, brand].join('|');
    if (this.smsConsentContextKey === contextKey) {
      return;
    }
    this.smsConsentContextKey = contextKey;
    this.smsConsentRequestId = this.orchestrationService.getAccountSmsConsent({
      brand,
      guid
    });
  }

  private isCurrentSmsConsentResponse(response: any): boolean {
    const requestId = response?.requestKey != null ? String(response.requestKey) : '';
    return requestId !== '' && requestId === this.smsConsentRequestId;
  }

  private portalSmsBrand(brand: string): string {
    const value = (brand || '').toString().trim().toUpperCase();
    if (value === 'TOY' || value === 'T' || value === 'TOYOTA') {
      return 'T';
    }
    if (value === 'LEX' || value === 'L' || value === 'LEXUS') {
      return 'L';
    }
    return '';
  }

  private applySmsConsent(value: string): void {
    this.customerForm?.controls?.smsConsent?.setValue(value);
  }
}
